import { formatCurrency, formatCurrencyWhole } from '../utils/api';
import { priceRangeBar } from '../utils/topProducts';

// Where a product's current price sits between the period's min and max — a
// small fixed-width bar with a dot, the friendly cousin of a stock's day range
// (owner, 20/10/2026). Used by the top-products REPORT (its list rows and
// desktop table); the /analysis card no longer shows it (#311).
//
// MAX IS ON THE RIGHT (owner): the box is dir="ltr", like money, so min reads
// left and max right whatever the page direction. The words מינ׳ / מקס׳ are
// printed once, in the list's header — each row carries only the numbers.
// The bar is a fixed width so the ten dots line up in one column you can scan.
// The dot is neutral: red/green belong to the change chip beside the price.
//
// No bar when it would mislead (utils/topProducts.js priceRangeBar): one
// purchase, a flat or near-flat price, or a spread so wide the units probably
// differ.
const endPrice = (n) => (n >= 100 ? formatCurrencyWhole(n) : formatCurrency(n));

export default function PriceRange({ row }) {
  const state = priceRangeBar(row);
  if (!state) return null;
  if (state.kind === 'single') return <span className="price-range-note">קנייה אחת</span>;
  if (state.kind === 'flat') return <span className="price-range-note">מחיר יציב</span>;
  if (state.kind === 'units') return <span className="price-range-note" title="פער חריג בין המחירים — ייתכן שמדובר ביחידות שונות">—</span>;
  return (
    <span
      className="price-range"
      dir="ltr"
      role="img"
      aria-label={`מינ׳ ${formatCurrency(state.min)}, מקס׳ ${formatCurrency(state.max)}, מחיר נוכחי ${formatCurrency(row.current_price)}`}
    >
      <span className="price-range-end">{endPrice(state.min)}</span>
      <span className="price-range-track">
        <span className="price-range-dot" style={{ left: `${state.pos * 100}%` }} />
      </span>
      <span className="price-range-end">{endPrice(state.max)}</span>
    </span>
  );
}
